import styled from 'styled-components';
import { StyledDataCell } from './StyledDataCell';

export const StyledFooterCell = styled(StyledDataCell)`
  border-top: thin solid ${({ theme }) => theme.borderColor};
  background: white;
  font-weight: 500;
`;

export default StyledFooterCell;
